import { render, staticRenderFns } from "./WenzhenLog.vue?vue&type=template&id=7135542c&scoped=true"
import script from "./WenzhenLog.vue?vue&type=script&lang=js"
export * from "./WenzhenLog.vue?vue&type=script&lang=js"
import style0 from "./WenzhenLog.vue?vue&type=style&index=0&id=7135542c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7135542c",
  null
  
)

export default component.exports